import { fiscalDate } from '@makila/fiscal';
/**
 * Estado efectivo da subscrição — calculado sempre a partir das datas, para
 * que o fim do teste ou de um período pago tenha efeito no próprio dia, mesmo
 * que o job diário que grava a transição ainda não tenha corrido.
 *
 *  - suspended / closed / read_only: decisões manuais do operador, prevalecem;
 *  - trial: termina em trial_ends_at → só leitura;
 *  - active / past_due: válido até paid_until (sem data = cortesia, sem fim);
 *    depois, GRACE_DAYS de tolerância em "pagamento em atraso" → só leitura.
 *
 * Em só leitura consulta-se e exporta-se tudo (a lei exige acesso aos dados
 * fiscais); só se bloqueiam escritas.
 */
export const GRACE_DAYS = 7;
const day = (d) => (typeof d === 'string' ? d.slice(0, 10) : d.toISOString().slice(0, 10));
const addDays = (iso, n) => { const d = new Date(`${iso}T00:00:00Z`); d.setUTCDate(d.getUTCDate() + n); return day(d); };
const diff = (a, b) => Math.round((Date.parse(`${a}T00:00:00Z`) - Date.parse(`${b}T00:00:00Z`)) / 86_400_000);
export function subscriptionState(t, today) {
    const s = t.status;
    if (s === 'suspended')
        return { status: s, writable: false, until: null, daysLeft: null, reason: 'Conta suspensa pelo operador. Contacte o suporte.' };
    if (s === 'closed')
        return { status: s, writable: false, until: null, daysLeft: null, reason: 'Conta encerrada.' };
    if (s === 'read_only')
        return { status: s, writable: false, until: null, daysLeft: null, reason: 'Conta em modo de só leitura. Regularize a subscrição para voltar a emitir.' };
    if (s === 'trial') {
        // trial_ends_at é um instante: o último dia é o do calendário de Maputo, não o UTC
        // (um registo às 23h de Maputo terminava um dia antes do prometido).
        const end = t.trial_ends_at ? fiscalDate(new Date(t.trial_ends_at)) : null;
        if (end && today > end)
            return { status: 'read_only', writable: false, until: end, daysLeft: 0, reason: 'O período de teste terminou. Escolha um plano para continuar a facturar.' };
        return { status: 'trial', writable: true, until: end, daysLeft: end ? diff(end, today) : null, reason: null };
    }
    // active / past_due
    if (!t.paid_until)
        return { status: 'active', writable: true, until: null, daysLeft: null, reason: null };
    const paid = day(t.paid_until);
    if (today <= paid)
        return { status: 'active', writable: true, until: paid, daysLeft: diff(paid, today), reason: null };
    const graceEnd = addDays(paid, GRACE_DAYS);
    if (today <= graceEnd)
        return { status: 'past_due', writable: true, until: graceEnd, daysLeft: diff(graceEnd, today), reason: `Subscrição vencida a ${paid.split('-').reverse().join('/')}. Regularize até ${graceEnd.split('-').reverse().join('/')} para evitar o modo de só leitura.` };
    return { status: 'read_only', writable: false, until: graceEnd, daysLeft: 0, reason: 'A subscrição venceu. Regularize o pagamento para voltar a emitir.' };
}
/**
 * Funcionalidades de plano (chaves de `plans.features`). Fonte única para a
 * consola da plataforma: a lista do ecrã de planos estava escrita à mão e não
 * coincidia com as chaves gravadas (faltavam pagamentos móveis, portal e
 * filiais; sobravam chaves que nada lia).
 */
export const PLAN_FEATURES = {
    stock: 'Stock e inventários',
    purchases: 'Compras e fornecedores',
    whatsapp: 'Envio por WhatsApp',
    mobile_payments: 'Pagamentos móveis (M-Pesa, e-Mola, mKesh)',
    portal: 'Portal do cliente',
    api: 'Acesso à API',
    multi_branch: 'Várias filiais e armazéns',
    priority_support: 'Suporte prioritário',
    pos_integration: 'Integração com o Makila POS',
};
//# sourceMappingURL=subscription.js.map